<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";

/**
 * Invoice-detail component
 */
export default {
    components: { ErrorMessage,Layout, PageHeader },
    data() {
        return {
            errorMessage: "",
            title: "Agent and Company Details",
            items: [
                {
                    text: "Agent",
                    href: "/"
                },
                {
                    text: "Details",
                    active: true
                }
            ],
            errors: null,
            agent_uuid:"",
            agent:[],
            agency:[],
            user:[],
            booking:"",
            status:"",
            visible:false,
            message:"",
        };
    },
    created() {
        this.agent_uuid = this.$route.params.id;
    },
    mounted() {
        this.getAgentDetails();
    },
    methods: {
        onClose(){
            this.visible=false;
        },
        async userStatusWarning(id) {
            var _this = this;
            try {
                this.$swal({
                    title: "Are you sure?",
                    text: "You can't revert your action",
                    type: "error",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Change status!",
                    cancelButtonText: "No",
                    showCloseButton: true,
                    showLoaderOnConfirm: true,
                }).then((result) => {
                    if (result.value) {
                        _this.userStatus(id);
                    } else {
                        this.$swal("Cancelled", "", "info");
                    }
                });
            } catch (err) {
                console.log(err);
            }
        },
        async userStatus(id) {
            try {
                axios
                    .post("/api/user/b2c/status/" + id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.status=response.data.data.status;
                            this.$swal("Status Changed Successfully");
                            this.getAgentDetails();
                            // location.reload();
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        getAgentDetails(){
            var _this = this;
            let uuid=this.agent_uuid;
            try{
                axios
                    .post("/api/user-agent/detail/" + uuid, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.agent=response.data.data.data;
                            this.agency=response.data.data.data.agency_information[0];
                            this.user=response.data.data.data.users[0];
                        }else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            _this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        errorCheck(obj) {
            if(obj.statusCode == 403){
                this.visible=true;
                this.message="Access Permission Denied";
                this.errors = obj.message;
            }else if (obj.error) {
                this.errors = obj.message;
            } else if (obj.message == "Token has expired") {
                this.$swal.fire({
                    title: 'LogOut!',
                    text: 'Token Has Expired',
                    icon: 'error',
                    toast:'true',
                    position: 'top-end',
                });
                this.$router.push({ name: "logout" });
            } else if (
                obj.message !== "Token has expired" &&
                obj.message !== "The given data was invalid."
            ) {
                this.errors = obj.message;
            } else if (obj.message == "The given data was invalid.") {
                this.errors = obj.errors;
            } else {
                this.flashMessage.show({
                    time: 5000,
                    status: "error",
                    title: "Error",
                    message: "Problem in data save",
                });
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-xl-4">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title mb-4">{{agency.agency_name}}</h5>
                       <div class="row">
                           <div class="col-5">
                               <img
                                   class="rounded-circle avatar-xl"
                                   alt="N/A"
                                   :src="agency.agency_logo"
                                   data-holder-rendered="true"
                               />
                           </div>
                           <div class="col-7">
                               <div class="padding-10px">
                                   <router-link :to="{ name: 'flight_booking_list', params: {user_id: agent_uuid } }" class="btn btn-outline-primary btn-sm" :disabled="true"> <i class="bx bx-show-alt"></i> Booking</router-link>
                               </div>
                               <div class="padding-10px">
                                   <router-link :to="{ name: 'ledger_list', params: {user_id: agent_uuid } }" class="btn btn-outline-primary btn-sm" :disabled="true"> <i class="bx bx-show-alt"></i> Ledger</router-link>
                               </div>
                               <div class="padding-10px">
                                   <router-link :to="{ name: 'booking_partial_payment_list', params: {user_id: agent_uuid } }" class="btn btn-outline-primary btn-sm" :disabled="true"> <i class="bx bx-show-alt"></i> Partial Payment</router-link>
                               </div>
                           </div>
                       </div>
                        <div class="table-responsive">
                            <table class="table mb-0">
                                <tbody>
                                <tr>
                                    <td class="card-title mb-4">Agent ID :</td>
                                    <td>{{user.username}}</td>
                                </tr>
                                <tr>
                                    <td class="card-title mb-4">Registration Date:</td>
                                    <td>{{user.created_at | moment("D MMM YYYY")}}</td>
                                </tr>
                                <tr>
                                    <td class="card-title mb-4">Balance:</td>
                                    <td v-if="user.user_wallet!=null">{{user.user_wallet==null ? 'N/A' : user.user_wallet.currency}} {{user.user_wallet==null ? 'N/A' : user.user_wallet.main_balance}}</td>
                                    <td v-else>N/A</td>
                                    <td><router-link :to="{ name: 'deposit_add_balance', params: {user_id: agent_uuid } }" class="btn btn-outline-primary btn-sm" :disabled="true"> <i class="fas fa-edit"></i> Deposit</router-link></td>
                                </tr>
                                <tr>
                                    <td class="card-title mb-4">Status :</td>
                                    <td>{{user.status}}</td>
                                    <td><button class="btn btn-outline-primary btn-sm" @click.prevent="userStatusWarning(user.uuid)"><i class="fas fa-edit"></i> {{user.status=='active' ? 'Deactivate' : 'Activate'}}</button></td>

                                </tr>
                                <tr>
                                    <td class="card-title mb-4">Account Approval :</td>
                                    <td>{{agent.approval_status}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="card">
                    <div class="row">
                        <div class="col col-lg-6">
                            <div class="card">
                                <div class="card-body">
<!--                                    <span class="card-title">-->
<!--                                       Company Information-->
<!--                                    </span>-->
                                 <div>
                                        <span class="card-title">
                                        Company Name :
                                    </span>
                                     <span>
                                        {{agency.agency_name}}
                                    </span>
                                 </div>
                                   <div>
                                        <span class="card-title">
                                        IATA Registered :
                                    </span>
                                       <span>
                                        {{agency.iata_no==null ? 'no' : 'yes'}}
                                    </span>
                                   </div>
                                   <div>
                                        <span class="card-title">
                                        Fax :
                                    </span>
                                       <span>
                                        {{agency.fax_no==null ? 'N/A' : agency.fax_no}}
                                    </span>
                                   </div>
                                   <div>
                                        <span class="card-title">
                                        Website :
                                    </span>
                                       <span v-if="agency.website != null">
                                        <a :href="agency.website"></a>
                                    </span>
                                       <span v-else>N/A</span>
                                   </div>
                                </div>
                                <div class="card-body">
                                    <span class="card-title">
                                       Owner Information
                                    </span>
                                    <div>
                                        <span class="card-title">
                                        Name :
                                    </span>
                                        <span>
                                        {{agency.management_full_name==null ? 'N/A' : agency.management_full_name}}
                                    </span>
                                    </div>
                                    <div>
                                        <span class="card-title">
                                        Phone :
                                    </span>
                                        <span>
                                       {{agency.management_phone_number==null ? 'N/A' : agency.management_phone_number}}
                                    </span>
                                    </div>
                                  <div>
                                        <span class="card-title">
                                        Email :
                                    </span>
                                      <span>
                                       {{agency.management_email==null ? 'N/A' : agency.management_email}}
                                    </span>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="col col-lg-6">
                            <div class="card">
                                <div class="card-body">
                                    <span class="card-title">
                                       Address Information
                                    </span>
                                    <div>
                                        {{agency.address}}
                                    </div>
                                    <div>
                                        {{agency.city}}
                                    </div>
                                    <div>
                                        {{agency.country}}
                                    </div>
                                </div>
                                <div class="card-body">
                                    <span class="card-title">
                                     User / Contact Information
                                    </span>
                                   <div>
                                        <span class="card-title">
                                        Name :
                                    </span>
                                       <span>
                                        {{agency.contact_person_full_name==null ? 'N/A' : agency.contact_person_full_name}}
                                    </span>
                                   </div>
                                 <div>
                                        <span class="card-title">
                                        Phone :
                                    </span>
                                     <span>
                                       {{agency.contact_person_phone_number==null ? 'N/A' : agency.contact_person_phone_number}}
                                    </span>
                                 </div>
                             <div>
                                        <span class="card-title">
                                        Email :
                                    </span>
                                 <span>
                                       {{agency.contact_person_email==null ? 'N/A' : agency.contact_person_email}}
                                    </span>
                             </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   <div class="card-body">
                       <div class="row">
                           <div class="col-lg-4">
                               <div class="card-title">
                                   Business / Trade License
                               </div>
                               <div>
                                   {{agency.trade_license_no}}
                               </div>
                           </div>
                           <div class="col-lg-4">
                               <div class="card-title">
                                   Civil Aviation Certificate
                               </div>
                               <div>
                                   {{agency.civil_aviation_certificate_no}}
                               </div>
                           </div>
                           <div class="col-lg-4">
                               <div class="card-title">
                                   IATA
                               </div>
                               <div>
                                   {{agency.iata_no}}
                               </div>
                           </div>
                       </div>
                   </div>

                    </div>
                </div>
            </div>

    </Layout>
</template>
<style scoped>
.padding-10px{
    padding:5px;
}
</style>

